<template>
  <v-row>
    <buy-pack-dialog v-if="buy" :code="buy" :value="true" @purchase="$emit('purchase')" @input="buy = null" />

    <div v-if="collapse" class="pt-3 btn-group mx-auto">
      <v-btn class="btn-group-right" :input-value="key == '5-pack'" @click="key = '5-pack'">5-pack</v-btn>
      <v-btn class="btn-group-left" :input-value="key == '50-pack'" @click="key = '50-pack'">50-pack</v-btn>
    </div>

    <v-col
      v-for="[ name, color, price, perCardPrice, code ] in cards"
      :key="code"
      class="flex-grow-1 pb-16"
      :cols="collapse ? 12 : 6"
    >
      <v-card class="fill-height relative white--text text-center" hover @click="buy = code">
        <div class="pa-3" :class="color">
          <div class="mb-3 title font-weight-bold">{{name}}</div>
          <price class="text-h5 font-weight-bold" color="white" :value="price" />
          <br>
          <price class="font-weight-bold" color="white" :value="perCardPrice" per="card" />
        </div>

        <div class="absolute text-center pa-2" style="width: 100%; top: 100%;">
          <v-btn color="primary">Select</v-btn>
        </div>

        <v-divider />

        <v-card-text class="pa-3 lighten-5" :class="color">
          <template v-if="showDetails">
            <div>Includes personal cards, group cards, and event invitations</div>
            <div class="mt-6">Share credits across your organization</div>
            <div class="mt-6">Credits never expire</div>
          </template>
          <template v-else>
            <router-link @click.stop :to="{ name: 'pricing', hash: '#bulk-packs' }">Learn more…</router-link>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import BuyPackDialog from '@/components/BuyPackDialog.vue';
import Price from '@/components/Price.vue';
import SignInDialog from '@/components/SignInDialog.vue';

const CARD_PROPS = {
  '5-pack': [ 'deep-orange', '19.95', '3.99', '5-PACK@3.99' ],
  '50-pack': [ 'orange', '149.50', '2.99', '50-PACK@2.99' ]
};

export default {
  name: 'pricing-bulk-packs',

  components: {
    BuyPackDialog,
    Price,
    SignInDialog
  },

  props: {
    collapse: Boolean,
    showDetails: Boolean
  },

  data() {
    return {
      key: '5-pack',
      buy: null
    };
  },

  created() {
    Object.assign(this, { CARD_PROPS });
  },

  computed: {
    cards() {
      return (this.collapse ? [ this.key ] : [ '5-pack', '50-pack' ]).map(x => [ x, ...CARD_PROPS[x] ]);
    }
  }
}
</script>
